import AddressField from "@/app/core/layouts/main-components/delivery/AddressField";
import { Autocomplete } from "@/app/core/util/helpers/AutocompleteHelper";
import OnDataChange from "@/app/core/util/helpers/HandleChange";
import { Countries } from "@/app/core/util/helpers/MoneyHelper";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import React, { useState } from "react";
import { useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { toast } from "react-toastify";

export default function AddressStep({ infos,
    reportAddresses,
    reportOriginResponsible,
    reportDestinationResponsible,
    addressBook }) {
    const [origin, setOrigin] = useState({})
    const [destination, setDestination] = useState({})
    const [resultsDestination, setResultsDestination] = useState([])
    const [resultsOrigin, setResultsOrigin] = useState([])
    const [setQuery] = useState("");

    useEffect(() => {
        loadInfos()
    }, [infos])

    function loadInfos() {
        if (infos.origin != undefined && infos.destination != undefined) {
            setOrigin(infos.origin)
            setDestination(infos.destination)
        }
    }

    function handleOriginChange(evt, type) {
        setOrigin(OnDataChange(origin, evt, type));
        if (evt.target.name == "country_code") {
            setResultsOrigin(autocomplete(evt.target.value))
        }
    }

    function reportOrigin(address) {
        if (address.country_code != "BR") {
            delete address.neighborhood;
        }
        setOrigin({ ...origin, ...address });
    }

    function handleDestinationChange(evt, type) {
        setDestination(OnDataChange(destination, evt, type));
        if (evt.target.name == "country_code") {
            setResultsDestination(autocomplete(evt.target.value))
        }
    }

    function autocomplete(value) {
        let countries_to_show = [];

        if (value.length > 0) {
            countries_to_show = Autocomplete(value, Countries, "Name");
            return countries_to_show;
        } else {
            countries_to_show = [];
            return [];
        }
    }

    function reportDestination(address) {
        if (address.country_code != "BR") {
            delete address.neighborhood;
        }
        setDestination({ ...destination, ...address });
    }

    function endAddresses() {
        let message = "";
        let messageDestination = "";
        let error = false;
        if (!origin.zipCode) {
            message += `${Translate(Message.PostalCode)}; `;
        }
        if (!origin.number) {
            message += `${Translate(Message.Number)}; `;
        }
        if (!origin.country_code) {
            message += `${Translate(Message.Country)}; `;
        }
        // if (!origin.state) {
        //     message += "Estado; ";
        // }
        if (!origin.city) {
            message += `${Translate(Message.City)}; `;
        }
        if (!origin.name) {
            message += `${Translate(Message.SendersName)}; `;
        }
        if (message.length > 0) {
            toast.error(`${message}`);
            error = true;
        }

        if (!destination.zipCode) {
            messageDestination += `${Translate(Message.PostalCode)}; `;
        }
        if (!destination.number) {
            messageDestination += `${Translate(Message.Number)}; `;
        }
        if (!destination.country_code) {
            messageDestination += `${Translate(Message.Country)}; `;
        }
        // if (!destination.state) {
        //     messageDestination += "Estado; ";
        // }
        if (!destination.city) {
            messageDestination += `${Translate(Message.City)}; `;
        }
        if (!destination.name) {
            messageDestination += `${Translate(Message.RecipientName)}; `;
        }
        if (messageDestination.length > 0) {
            toast.error(`${messageDestination}`);
            error = true;
        }
        if (origin.country_code == destination.country_code && origin.country_code == "BR") {
            if (!origin.neighborhood || !destination.neighborhood) {
                toast.error(Translate(Message.MandatoryNeighborhood));
                error = true;
            }
        }

        if (error) {
            return;
        } else {
            reportAddresses({ origin, destination });
        }
    }

    function selectOrigin(item) {
        let base = { ...origin, ...item };
        base.country_code = item.country;
        base.state_code = item.state;
        base.address = `${item.number}, ${item.street}, ${item.neighborhood} | ${item.city} - ${item.state}`
        setOrigin(base);
        reportOriginResponsible(base);
    }

    function selectDestination(item) {
        let base = { ...destination, ...item };
        base.country_code = item.country;
        base.state_code = item.state;
        base.address = `${item.number}, ${item.street}, ${item.neighborhood} | ${item.city} - ${item.state}`
        setDestination(base);
        reportDestinationResponsible(base);
    }

    return (
        <div className="row">
            {/* Origem */}
            <div className="block block-rounded block-bordered block-fx-pop mb-0 border-success col-md-6" key={`card-origin`}>
                <div className="block-header">
                    <div className="block-title">
                        <i className="fa fa-map-marker-alt text-info mr-2"></i>{Translate(Message.OriginAddress)}
                    </div>
                    <div className="block-tools">
                        <button className="btn btn-dual" onClick={() => setOrigin({ zipCode: "", number: "", complement: "", address: "", city: "", state: "", country: "", country_code: "", name: "" })}>{Translate(Message.ClearFields)}</button>
                        {addressBook && addressBook.length > 0 ?
                            <Dropdown style={{ zIndex: 21 }} >
                                <Dropdown.Toggle variant="light">
                                    <i className="fa fa-search" /> Procurar
                                </Dropdown.Toggle>
                                <Dropdown.Menu style={{ width: 300 }}>
                                    <Typeahead
                                        options={addressBook}
                                        labelKey={(option) => `${option.name} - ${option.state} - ${option.country}`}
                                        onSearch={(q) => setQuery(q)}
                                        name="country_code"
                                        placeholder="Selecionar"
                                        id={`coleta-responsavel`}
                                        onChange={(selected) => {
                                            if (selected[0] !== undefined || selected !== null) {
                                                selectOrigin(selected[0])
                                            }
                                        }} />
                                </Dropdown.Menu>
                            </Dropdown>
                            : ""}
                    </div>
                </div>
                <div className="ml-2 mr-2 mb-2 row">
                    <div className="col-md-12">
                        <AddressField address={origin && origin.address} teste={origin} reportAddress={address => reportOrigin(address)} />
                    </div>
                    <div className="form-group col-md-4">
                        <span>*{Translate(Message.PostalCode)}</span>
                        <input
                            type="text"
                            className="form-control"
                            key={`zipCode-origin`}
                            name="zipCode"
                            value={origin && origin.zipCode}
                            onChange={(evt) => handleOriginChange(evt)}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <span>*{Translate(Message.Number)}</span>
                        <input type="text" className="form-control" name="number" value={origin && origin.number} onChange={evt => handleOriginChange(evt)}
                            key={`number-origin`} />
                    </div>
                    <div className="form-group col-md-4">
                        <span>{Translate(Message.Complement)}</span>
                        <input type="text" className="form-control" name="complement" value={origin && origin.complement} onChange={evt => handleOriginChange(evt)}
                            key={`complement-origin`} />
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <span>*{Translate(Message.Country)}</span>
                            <input
                                name="country_code"
                                placeholder="Selecionar"
                                className="form-control"
                                key={`country-origin`}
                                defaultInputValue={origin && origin.country_code}
                                value={origin && origin.country_code}
                                onChange={(evt) => handleOriginChange(evt)} />

                            <ul
                                style={resultsOrigin && resultsOrigin.length > 0 ? {
                                    borderRadius: "3px",
                                    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                    background: "rgba(255, 255, 255, 0.9)",
                                    padding: "2px 0",
                                    fontSize: "90%",
                                    position: "fixed",
                                    overflow: "auto",
                                    marginTop: 10,
                                    width: "30%",
                                    zIndex: 999999,
                                    maxHeight: "300px", // TODO: don't cheat, let it flow to the bottom
                                } : {
                                    borderRadius: "3px",
                                }}>
                                {resultsOrigin && resultsOrigin.map((item) => {
                                    return (
                                        <li
                                            className="m-3"
                                            onClick={() => setOrigin({ ...origin, country_code: item.Code }) | setResultsOrigin([])}
                                        >
                                            {`(${item.Code}) ${item.Name}`}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                    <div className="form-group col-md-4">
                        <span>*{Translate(Message.State)}</span>
                        <input type="text" className="form-control" name="state" value={origin && origin.state} onChange={evt => handleOriginChange(evt)} />
                    </div>
                    <div className="form-group col-md-4">
                        <span>*{Translate(Message.City)}</span>
                        <input type="text" className="form-control" name="city" value={origin && origin.city} onChange={evt => handleOriginChange(evt)} />
                    </div>
                    {origin && origin.country_code == "BR" ?
                        <div className="form-group col-md-6">
                            <span>{Translate(Message.Neighborhood)}</span>
                            <input type="text" className="form-control" name="neighborhood" placeholder="" value={origin && origin.neighborhood} onChange={evt => handleOriginChange(evt)} />
                        </div>
                        : ""}
                    <div className={origin && origin.country_code == "BR" ? "form-group col-md-6" : "form-group col-md-12"}>
                        <span>*{Translate(Message.SendersName)}</span>
                        <input type="text" className="form-control" name="name" placeholder="Ex: Empresa LTDA ou Jhon Doe" value={origin && origin.name} onChange={evt => handleOriginChange(evt)} />
                    </div>
                </div>
            </div>

            {/* Destino */}
            <div className="block block-rounded block-bordered block-fx-pop mb-0 border-success col-md-6" key={`card-destination`}>
                <div className="block-header">
                    <div className="block-title">
                        <i className="fa fa-flag-checkered text-success mr-2"></i>{Translate(Message.DestinationAddress)}
                    </div>
                    <div className="block-tools">
                        <button className="btn btn-dual" onClick={() => setDestination({ zipCode: "", number: "", complement: "", address: "", city: "", state: "", country: "", country_code: "", name: "" })}>{Translate(Message.ClearFields)}</button>
                        {addressBook && addressBook.length > 0 ?
                            <Dropdown>
                                <Dropdown.Toggle variant="light">
                                    <i className="fa fa-search" /> Procurar
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Typeahead
                                        options={addressBook}
                                        labelKey={(option) => `${option.name} - ${option.state} - ${option.country}`}
                                        onSearch={(q) => setQuery(q)}
                                        name="country_code"
                                        placeholder="Selecionar"
                                        id={`coleta-responsavel`}
                                        onChange={(selected) => {
                                            if (selected[0] !== undefined || selected !== null) {
                                                selectDestination(selected[0])
                                            }
                                        }} />
                                </Dropdown.Menu>
                            </Dropdown>
                            : ""}
                    </div>
                </div>
                <div className="ml-2 mr-2 mb-2 row">
                    <div className="col-md-12">
                        <AddressField address={destination && destination.address} teste={destination} reportAddress={address => reportDestination(address)} />
                    </div>
                    <div className="form-group col-md-4">
                        <span>*{Translate(Message.PostalCode)}</span>
                        <input
                            type="text"
                            className="form-control"
                            key={`zipCode-destination`}
                            name="zipCode"
                            value={destination && destination.zipCode}
                            onChange={(evt) => handleDestinationChange(evt)}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <span>*{Translate(Message.Number)}</span>
                        <input type="text" className="form-control" name="number" value={destination && destination.number} onChange={evt => handleDestinationChange(evt)}
                            key={`number-destination`} />
                    </div>
                    <div className="form-group col-md-4">
                        <span>{Translate(Message.Complement)}</span>
                        <input type="text" className="form-control" name="complement" value={destination && destination.complement} onChange={evt => handleDestinationChange(evt)}
                            key={`complement-destination`} />
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <span>*{Translate(Message.Country)}</span>
                            <input
                                name="country_code"
                                placeholder="Selecionar"
                                className="form-control"
                                key={`country-destination`}
                                defaultInputValue={destination && destination.country_code}
                                value={destination && destination.country_code}
                                onChange={(evt) => handleDestinationChange(evt)} />

                            <ul
                                style={resultsDestination && resultsDestination.length > 0 ? {
                                    borderRadius: "3px",
                                    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                    background: "rgba(255, 255, 255, 0.9)",
                                    padding: "2px 0",
                                    fontSize: "90%",
                                    position: "fixed",
                                    overflow: "auto",
                                    marginTop: 10,
                                    width: "30%",
                                    zIndex: 999999,
                                    maxHeight: "300px", // TODO: don't cheat, let it flow to the bottom
                                } : {
                                    borderRadius: "3px",
                                }}>
                                {resultsDestination && resultsDestination.map((item) => {
                                    return (
                                        <li
                                            className="m-3"
                                            onClick={() => setDestination({ ...destination, country_code: item.Code }) | setResultsDestination([])}
                                        >
                                            {`(${item.Code}) ${item.Name}`}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                    <div className="form-group col-md-4">
                        <span>{Translate(Message.State)}</span>
                        <input type="text" className="form-control" name="state" key="stateDestination" value={destination && destination.state} onChange={evt => handleDestinationChange(evt)} />
                    </div>
                    <div className="form-group col-md-4">
                        <span>*{Translate(Message.City)}</span>
                        <input type="text" className="form-control" name="city" key="cityDestination" value={destination && destination.city} onChange={evt => handleDestinationChange(evt)} />
                    </div>
                    {destination && destination.country_code == "BR" ?
                        <div className="form-group col-md-6">
                            <span>{Translate(Message.Neighborhood)}</span>
                            <input type="text" className="form-control" name="neighborhood" placeholder="" value={destination && destination.neighborhood} onChange={evt => handleDestinationChange(evt)} />
                        </div>
                        : ""}
                    <div className={destination && destination.country_code == "BR" ? "form-group col-md-6" : "form-group col-md-12"}>
                        <span>*{Translate(Message.RecipientName)}</span>
                        <input type="text" className="form-control" name="name" key="nameDestination" placeholder="Ex: Empresa LTDA ou Jhon Doe" value={destination && destination.name} onChange={evt => handleDestinationChange(evt)} />
                    </div>
                </div>
            </div>
            <div className="col-12 text-center mt-5">
                <button type="button" className="btn btn-hero-lg btn-hero-success mt-5" onClick={() => endAddresses()}>
                    {Translate(Message.Advance)} <i className="fa fa-arrow-right ml-2"></i>
                </button>
            </div>
        </div>
    )
}